import { render } from "./RecoveryCodeInput.vue?vue&type=template&id=72104a33&scoped=true"
import script from "./RecoveryCodeInput.vue?vue&type=script&lang=js"
export * from "./RecoveryCodeInput.vue?vue&type=script&lang=js"

import "./RecoveryCodeInput.vue?vue&type=style&index=0&id=72104a33&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72104a33"]])

export default __exports__